import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { Icons } from '../../assets';
import useDebounce from '../UseDebounce';

const SearchBox = (props) => {
    const { value, onChange, className, placeholder = 'Search...' } = props

    const [inputValue, setInputValue] = useState(value);
    const debouncedValue = useDebounce(inputValue, 300);

    useEffect(() => {
        onChange(debouncedValue);
    }, [debouncedValue, onChange]);

    return (
        <>
            <div className={`${classes.searchBoxWrapper} ${className}`}>
                <div className={classes.searchIcon}>
                    <img src={Icons.search} />
                </div>
                <input
                    type='text'
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder={placeholder}
                />
            </div>
        </>
    )
}

export default SearchBox